export const CONFIGCAT_SDK_KEYS: { [key in Environment]: string } = {
  production: 'configcat-sdk-1/mQ_dCO20B0qFE88BmJzD-Q/3nZizqBg2U6yWvAqF-xP2g',
  staging: 'configcat-sdk-1/mQ_dCO20B0qFE88BmJzD-Q/6opuvm9c3E2r-f272c5NsA',
  development: 'configcat-sdk-1/mQ_dCO20B0qFE88BmJzD-Q/6opuvm9c3E2r-f272c5NsA',
}